<template>
  <section class="o-container o-container--responsive mv-64">
    <div :style="landingStep">
      <div class="u-align-center mb-64">
        <bl-text-av tag="h2" variation="heading-32">
          {{ $options.features.title }}
        </bl-text-av>
      </div>
      <bl-flex-container-mv class="justify-center">
        <bl-flex-item-av :col="3">
          <new-webp-image-container
            :src="items[0].image"
            :alt="items[0].title"
            :is-ssr="isSSR"
            styles="width: 365px; height: 180px"
          />

          <bl-card-mv>
            <div class="ph-32 pv-24">
              <bl-text-av tag="h3" variation="subheading-20" class="mb-16">
                {{ items[0].title }}
              </bl-text-av>
              <bl-text-av>
                {{ items[0].subtitle }}
              </bl-text-av>
            </div>
          </bl-card-mv>
        </bl-flex-item-av>

        <bl-flex-item-av :col="2" />

        <bl-flex-item-av :col="3" />
      </bl-flex-container-mv>
      <bl-flex-container-mv class="justify-center">
        <bl-flex-item-av :col="3" />

        <bl-flex-item-av :col="2" />

        <bl-flex-item-av :col="3">
          <new-webp-image-container
            :src="items[1].image"
            :alt="items[1].title"
            :is-ssr="isSSR"
            styles="width: 365px; height: 180px"
          />

          <bl-card-mv class="mt-8">
            <div class="ph-32 pv-24">
              <bl-text-av tag="h3" variation="subheading-20" class="mb-16">
                {{ items[1].title }}
              </bl-text-av>
              <bl-text-av>
                {{ items[1].subtitle }}
              </bl-text-av>
            </div>
          </bl-card-mv>
        </bl-flex-item-av>
      </bl-flex-container-mv>
      <bl-flex-container-mv class="justify-center">
        <bl-flex-item-av :col="3">
          <new-webp-image-container
            :src="items[2].image"
            :alt="items[2].title"
            :is-ssr="isSSR"
            styles="width: 365px; height: 180px"
          />

          <bl-card-mv class="mt-8">
            <div class="ph-32 pv-24">
              <bl-text-av tag="h3" variation="subheading-20" class="mb-16">
                {{ items[2].title }}
              </bl-text-av>
              <bl-text-av>
                {{ items[2].subtitle }}
              </bl-text-av>
            </div>
          </bl-card-mv>
        </bl-flex-item-av>

        <bl-flex-item-av :col="2" />

        <bl-flex-item-av :col="3" />
      </bl-flex-container-mv>
    </div>
  </section>
</template>
<script>
/* istanbul ignore file */
import BlTextAv from '@bukalapak/bazaar-dweb-2/dist/components/BlTextAv';
import BlFlexContainerMv from '@bukalapak/bazaar-dweb-2/dist/components/BlFlexContainerMv';
import BlFlexItemAv from '@bukalapak/bazaar-dweb-2/dist/components/BlFlexItemAv';
import BlCardMv from '@bukalapak/bazaar-dweb-2/dist/components/BlCardMv';
import { Features as features } from 'shared/modules/seo/Homepage';
import NewWebpImageContainer from 'shared/components/NewWebpImageContainer';
import { assetURL } from 'shared/helpers/assetHelper';

export default {
  name: 'Features',

  features,

  components: {
    BlTextAv,
    BlFlexContainerMv,
    BlFlexItemAv,
    BlCardMv,
    NewWebpImageContainer,
  },

  computed: {
    isSSR() {
      return this.$root.isSSR;
    },
    landingStep() {
      return {
        'background-image': `url(${assetURL('transaction_flow_new.png', this.isSSR)})`,
        'background-position': 'center 147px',
        'background-size': this.isSSR ? '0px 0px' : '8.5%',
        'background-repeat': 'no-repeat',
      };
    },

    items() {
      return this.$options.features.items;
    },
  },
};
</script>
